<template>
  <div class="right">
    <div class="right_top">
      <!--面包屑-->
      <Breadcrumb separator=">">
        <BreadcrumbItem @click.native="back()" class="right-item"
          >首页</BreadcrumbItem
        >
        <BreadcrumbItem class="right-item1">{{ this.title }}</BreadcrumbItem>
        <BreadcrumbItem class="right-item1" v-if="state">{{
          this.name
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div v-if="title == '工作进度'" style="width: inherit;">
      <workProgressRight ref="workProgressRight"></workProgressRight>
    </div>
    <div v-else style="height: auto">
      <div style="min-height: 521px; overflow: hidden">
        <div
          class="right-item2"
          v-for="(item, index) in listB"
          :key="index"
          @click="jump(item)"
        >
          <div class="right-item3">
            {{ item.title ? item.title : item.projectName }}
          </div>
          <div class="right-item4">
            [{{ item.deployTime.substring(0, 10) }}]
          </div>
        </div>
      </div>
      <div>
        <page
          v-model="pageNum"
          :total="total"
          show-total
          show-sizer
          show-elevator
          class="pag"
          :current="pageNum"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 50, 100, 500]"
          @on-change="changeIndex"
          @on-page-size-change="changePageSize"
        ></page>
      </div>
    </div>
  </div>
</template>
<script>
import  workProgressRight from "./workProgressRight.vue"
export default {
  name: "insideRight",
  components:{workProgressRight},
  props: {
    right: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      listB: [],
      total: 0,
      pageNum: 1, //当前页码
      pageSize: 10, // 当前页大小
      cmsId: "",
      title: "",
      name: "",
      state: false,
      address: ""
    };
  },
  watch: {
    right: {
      handler: function(to, from) {
        //初始化对应数据，如果传入的参数有name则显示，否则不显示
        this.cmsId = this.right.cmsId;
        this.title = this.right.title;
        if (this.right.name) {
          this.state = true;
          this.name = this.right.name;
        } else {
          this.state = false;
          this.name = "";
        }
        this.pageNum = 1;
        //根据cmsId来动态获取对应咨询列表
        this.getList(this.cmsId, this.pageNum, this.pageSize);
        if(this.title == "工作进度"){
          this.$refs.workProgressRight.showTable()
        }
      },
      deep: true
    }
  },
  mounted() {
    //初始化对应数据，如果传入的参数有name则显示，否则不显示
    this.cmsId = this.right.cmsId;
    this.title = this.right.title;
    if (this.right.name) {
      this.state = true;
      this.name = this.right.name;
    } else {
      this.state = false;
      this.name = "";
    }
    this.pageNum = 1;
    //根据cmsId来动态获取对应咨询列表
    this.getList(this.cmsId, this.pageNum, this.pageSize);
  },
  methods: {
    changeIndex(value) {
      this.pageNum = value;
      this.getList(this.cmsId, value, this.pageSize);
    },
    // 调整页面大小
    changePageSize(size) {
      // s为页面大小
      this.pageSize = size;
      this.getList(this.cmsId, this.pageNum, size);
    },
    getList(cmsId, pageNum, pageSize) {
      let pram = {
        // channels: "[\"01823EEA10DF7500DE7B93FB84B477F6\"]",
        channels: JSON.stringify([cmsId]),
        filter: JSON.stringify({ deployed: 1 }),
        pageInfo: JSON.stringify({
          pageNum: pageNum,
          pageSize: pageSize
        })
      };
      GMS.$http
        .post("/portal/cms/view/contents", pram, {})
        .then(res => {
          if (res.status == 200) {
            this.listB = res.data.bean;
            this.total = res.data.total;
          }
        })
        .catch(error => {
          this.$Message.error("获取数据异常，请联系管理员");
        });
    },
    jump(res) {
      console.log(this.name)
      let Modal_show = true;
      GMS.$http
        .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
          userName: JSON.parse(sessionStorage.getItem("person"))
        })
        .then(value => {
          if (value.status == 200) {
            Modal_show = value.data;
            //如果为登录且加密，我们弹出对应界面
            if (!Modal_show) {
              GMS.vbus.$emit("Modal-Show");
              return;
            } else {
              if (this.$route.path.startsWith("/home")) {
                // 当前路由是以 /home 开头的
                if(this.title == '信息公开'){
                  this.$router.push({
                    path: "/home/infoDetail",
                    query: {
                      guid: res.guid,
                      title: this.title,
                      name: this.name,
                      total: res.title
                    }
                  });
                }else{
                  this.$router.push({
                    path: "/home/detail",
                    query: {
                      guid: res.guid,
                      title: this.title,
                      name: this.name,
                      total: res.title
                    }
                  });
                }

                
              } else if (this.$route.path.startsWith("/Portal")) {
                // 当前路由是以 /Portal 开头的
                this.$router.push({
                  path: "/Portal/detail",
                  query: {
                    guid: res.guid,
                    title: this.title,
                    name: this.name,
                    total: res.title
                  }
                });
              }
            }
          }
        });
    },
    back() {
      if (this.$route.path.startsWith("/home")) {
        // 当前路由是以 /home 开头的
        this.$router.push("/home");
      } else if (this.$route.path.startsWith("/Portal")) {
        // 当前路由是以 /Portal 开头的
        this.$router.push("/Portal");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.right {
  min-height: 687px;
  width: 926px;
  float: left;
  // margin-left: 32px;
  padding-bottom: 60px;
  // background-color: green;
}
.right_top {
  height: 42px;
  width: 926px;
  border-bottom: 1px solid #f3f3f3;
}
.pag {
  margin-top: 53px;
  text-align: right;
}
.demo-breadcrumb-separator {
  padding-left: 16px;
  line-height: 42px;
  color: #7f7f7f;
  font-size: 18px;
  font-weight: 400;
}
.right-item {
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  color: #424242;
  line-height: 42px;
  font-family: PingFangSC-S0pxibold;
}
.right-item1 {
  font-size: 18px;
  font-weight: 600;
  color: #424242;
  line-height: 42px;
  font-family: PingFangSC-S0pxibold;
}
.right-item2 {
  overflow: hidden;
  margin-top: 24px;
  cursor: pointer;
}
.right-item3 {
  float: left;
  line-height: 25px;
  font-size: 18px;
  font-weight: 400;
  color: #424242;
  font-family: PingFangSC-Regular;
}
.right-item4 {
  float: left;
  margin-left: 8px;
  line-height: 22px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px;
  color: #424242;
}

.itom {
  margin-top: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/inside/insideRight.vue